import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface LocalizationFiltersProps {
  selectedLocale: string;
  onLocaleChange: (locale: string) => void;
  searchTerm: string;
  onSearchChange: (search: string) => void;
  availableLocales: string[];
}

export function LocalizationFilters({
  selectedLocale,
  onLocaleChange,
  searchTerm,
  onSearchChange,
  availableLocales,
}: LocalizationFiltersProps) {
  return (
    <div className="flex flex-col sm:flex-row gap-4 mb-6">
      <div className="flex-1">
        <Label htmlFor="search" className="sr-only">
          Search translations
        </Label>
        <div className="relative">
          <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input
            id="search"
            placeholder="Search by key or text..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-8"
          />
        </div>
      </div>
      
      <div className="w-full sm:w-48">
        <Label htmlFor="locale" className="sr-only">
          Select language
        </Label>
        <Select value={selectedLocale} onValueChange={onLocaleChange}>
          <SelectTrigger id="locale">
            <SelectValue placeholder="Select language" />
          </SelectTrigger>
          <SelectContent>
            {availableLocales.map((locale) => (
              <SelectItem key={locale} value={locale}>
                {locale === 'en' ? 'English' : locale === 'ar' ? 'العربية (Arabic)' : locale}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}